import createErrorType from 'app/utils/createErrorType';
import { decodeOrThrow } from 'app/utils/ioTs';
import * as t from 'io-ts';

export interface IAuthenticateRequest {
  response_type: 'token' | 'code';
  client_id: string;
  redirect_uri?: string | undefined;
  scope?: string | undefined;
  state?: string | undefined;
}

export const AuthenticateRequestCodec: t.Type<IAuthenticateRequest> = t.intersection([
  t.interface({
    response_type: t.union([
      t.literal('token'),
      t.literal('code'),
    ]),
    client_id:     t.string,
  }),
  t.partial({
    redirect_uri: t.string,
    scope:        t.string,
    state:        t.string,
  }),
]);

class MalformedRequestError extends createErrorType('MalformedRequestError') {
}

export const parseAuthenticateRequest = (x: unknown) => {
  return decodeOrThrow(AuthenticateRequestCodec, x, (errors) => {
    throw new MalformedRequestError(errors.join('\n'));
  });
};
